module.exports = __webpack_public_path__ + "img/banner.0868d611.png";